<template>
  <div class="entry-container w-full relative">
    <div class="entry-title flex items-center">
      模拟面试
      <div class="entry-title-label flex justify-center items-center">
        WonderAI
      </div>
    </div>
    <div class="desc">AI 智能生成模拟面试问答</div>
    <CompleteButton
      :text="''"
      class="mock-interview-btn"
      @clickBtn="getInterviewQuestion"
    >
      <template v-slot:content>
        <div class="content flex items-center">
          <i
            v-if="questionState === 'loading'"
            class="iconfont iconzhengzaibaocun"
          ></i>
          {{ questionState === "loading" ? "AI 思考中" : "点击查看" }}
        </div>
      </template>
    </CompleteButton>
    <img
      src="https://logo.wondercv.com/banners/Vc4pDtKoRqp6lOm.png"
      alt=""
      class="absolute entry-icon"
    />
  </div>
</template>
<script>
import CompleteButton from "../CompleteButton/CompleteButton.vue";
export default {
  name: "MockInterviewEntry",
  props: {
    questionState: {
      type: String,
      default: "",
    },
  },
  components: {
    CompleteButton,
  },
  methods: {
    getInterviewQuestion() {
      this.$emit("getInterviewQuestion");
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/css/variable.scss";
.entry-container {
  padding: 24px 18px;
  border-radius: 18px;
  border: 1px solid $select-border-color !important;
  background: linear-gradient(
    45deg,
    $select-bg-start-color 0%,
    $select-bg-middle-color 62%,
    $select-bg-end-color 100%
  );
  .entry-title {
    font-size: 18px;
    font-weight: 500;
    color: $text-color;
    margin-bottom: 16px;
    .entry-title-label {
      width: 78px;
      height: 18px;
      margin-left: 6px;
      border-radius: 100px 100px 100px 0;
      background: linear-gradient(270deg, #e15d3f 0%, #febf5d 100%);
      color: $form-bg-color;
      font-size: 13px;
    }
  }
  .desc {
    color: #5a616e;
    font-size: 16px;
  }
  .mock-interview-btn {
    border-radius: 18px;
    width: 132px;
    height: 36px;
    font-size: 14px;
    margin-top: 24px;
    white-space: nowrap;
    .content {
      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
      .iconfont {
        font-size: 14px;
        margin-right: 6px;
        animation: spin 2s linear infinite;
      }
    }
  }
  .entry-icon {
    width: 144px;
    height: 136px;
    object-fit: contain;
    top: 50%;
    transform: translateY(-50%);
    right: 54px;
  }
}
</style>
